<template>
  <div>
    <div class="alert-box" style="margin-left: 120px">
      <Alert v-if="errors.length" type="danger" :messages="errors" />
    </div>
    <table class="table" v-show="!loading">
      <thead>
        <tr>
          <th style="width:451px">リスト名</th>
          <th style="width:318px">閲覧権限</th>
          <th style="width:150px">操作</th>
        </tr>
      </thead>
      <tbody>
        <ReviewListRow
          v-for="list in getReviewLists"
          v-bind:key="list._id"
          :reviewLists="list"
          @error="handleError"
        />
        <tr v-if="!getReviewLists.length">
          <td colspan="100%" class="text-center">リスト名が見つかりません</td>
        </tr>
      </tbody>
    </table>
    <Loader v-show="loading" />
  </div>
</template>

<script>
import Loader from '@/components/utils/Loader.vue';
import ReviewListRow from './ReviewListRow.vue';
import Alert from '@/components/utils/Alert.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'ReviewLists',
  components: { ReviewListRow, Loader, Alert },
  data() {
    return {
      loading: false,
      page: 1,
      pagination: {},
      errors: [],
    };
  },
  async mounted() {
    this.loading = true;
    if (!this.getCurrentUser) await this.loadCurrentUser();
    if (this.getReviewLists && !this.getReviewLists.length)
      await this.loadReviewLists();
    if (this.reviewListUsers && !this.reviewListUsers.length)
      await this.loadReviewListUsers();
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      getCurrentUser: 'getCurrentUser',
      isAdmin: 'currentUserIsAdmin',
      reviewListUsers: 'getReviewListUsers',
      getReviewLists: 'getReviewLists',
    }),
  },
  methods: {
    ...mapActions({
      loadReviewListUsers: 'reviewListUsers',
      loadCurrentUser: 'loadCurrentUser',
      loadReviewLists: 'loadReviewLists',
    }),
    handleError(message) {
      this.errors = message ? [message] : [];
    },
  },
};
</script>
<style scoped>
.table td {
  border-bottom: 1px solid #787878 !important;
}
table {
  width: 85%;
  margin: auto;
  position: relative;
}
.table thead {
  border-bottom: 1px solid #787878;
}
.table th {
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

</style>
